export const setFCUserProperties = (externalId, firstName, lastName, tags=[], email) => {
  window.fcWidget.user.setProperties({
    firstName : firstName && firstName, 
    lastName : lastName && lastName,
    email: email && email
  });

  window.fcWidget.setExternalId({
    externalId : externalId && externalId 
  });
};

export const initFreshChat = () => {
  var fcJS;
  fcJS = document.createElement('script');
  fcJS.id = 'freshchat-js-sdk';
  fcJS.async = true;
  fcJS.src = 'https://wchat.freshchat.com/js/widget.js';
  fcJS.onload = () => window.fcWidget.init({
      token: "cbd5a226-31b6-4527-b331-da44052382b7",
      host: "https://wchat.freshchat.com",
  });
  document.head.appendChild(fcJS);
};

export const destroyChat = () => {
  window.fcWidget && window.fcWidget.destroy();
};